import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import API_BASE_URL from '../apiConfig'; // <--- IMPORT
import '../App.css'; 

function ProfilePage() {
  const { token, user, setUser } = useAuth(); 
  const [companyName, setCompanyName] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (user && user.company_name) {
        setCompanyName(user.company_name);
    }
  }, [user]);

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
        // --- DYNAMIC URL ---
        const response = await axios.put(
            `${API_BASE_URL}/users/me`, 
            { company_name: companyName },
            { headers: { 'Authorization': `Bearer ${token}` } }
        );
        
        setUser(response.data);
        setMessage('✅ Profile updated successfully!');
    } catch (error) {
        console.error("Update failed", error);
        setMessage('❌ Failed to update profile.');
    } finally {
        setLoading(false);
    }
  };

  return (
    <div className="App">
      <Navbar />
      <header className="App-header">
        <div className="form-container" style={{maxWidth: '500px'}}>
          <h2 style={{textAlign: 'center'}}>Recruiter Profile</h2>
          
          {message && <div style={{marginBottom: '20px', textAlign: 'center', fontWeight: 'bold', color: message.includes('✅') ? 'green' : 'red'}}>{message}</div>}

          <form onSubmit={handleSave}>
            <div className="input-group">
                <label>Your Email (Read Only)</label>
                <input type="text" value={user?.email || ''} disabled style={{backgroundColor: '#f0f0f0', color: '#666'}} />
            </div>

            <div className="input-group" style={{marginTop: '20px'}}>
                <label>Company Name</label>
                <p style={{fontSize: '0.8rem', color: '#666', margin: '5px 0'}}>
                    This name will appear in emails sent to candidates (e.g., "You are invited by <strong>Your Company Name</strong>").
                </p>
                <input 
                    type="text" 
                    value={companyName} 
                    onChange={(e) => setCompanyName(e.target.value)}
                    placeholder="e.g. Luxer Graphics"
                    required 
                />
            </div>

            <button className="generate-button" type="submit" disabled={loading} style={{marginTop: '30px'}}>
                {loading ? 'Saving...' : 'Save Profile'}
            </button>
          </form>
        </div>
      </header>
      <Footer />
    </div>
  );
}

export default ProfilePage;